module.exports = __webpack_public_path__ + "img/lite-pool.e2d49007.jpg";